import { ApiError } from '../../api/errors';

/**
 * Завантаження файлу з API (експорт CSV тощо) тим самим сеансом: запит із cookie й заголовком X-ERS-Client,
 * помилка сервера — ApiError з поясненням українською. Ім’я файлу — із Content-Disposition або типове.
 */
export async function downloadFromApi(path: string, fallbackName: string): Promise<void> {
  let res: Response;
  try {
    res = await fetch(path, { credentials: 'include', headers: { 'x-ers-client': 'web', accept: 'text/csv, application/json' } });
  } catch {
    throw ApiError.network();
  }
  if (!res.ok) {
    let body: unknown = undefined;
    try {
      body = await res.json();
    } catch {
      body = undefined;
    }
    throw ApiError.fromResponse(res, body);
  }
  const blob = await res.blob();
  const cd = res.headers.get('content-disposition') ?? '';
  const star = /filename\*=UTF-8''([^;]+)/i.exec(cd);
  const plain = /filename="?([^";]+)"?/i.exec(cd);
  let name = fallbackName;
  try {
    if (star?.[1]) name = decodeURIComponent(star[1]);
    else if (plain?.[1]) name = plain[1];
  } catch {
    name = fallbackName;
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 2000);
}

/** Рядок запиту з непорожніх значень (для шляхів, які будуються вручну, напр. експорт). */
export function toQuery(params: Record<string, string | number | boolean | null | undefined>): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== null && v !== undefined && v !== '') q.set(k, String(v));
  const s = q.toString();
  return s ? `?${s}` : '';
}
